<crm-single-select
  #singleSelectComponent
  [options]="admins"
  [(selectedItem)]="_selectedAdmin"
  (selectedItemChange)="onSelectChange($event)"
  [label]="labelInput ? 'Администратор платежа' : ''"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="43"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [appendTo]="appendTo"
  [showClear]="showClear"
  filterBy="name,code">
  <ng-template
    #itemTemplate
    let-admin="item">
    <ng-container *ngIf="toRevenueAdmin(admin) as admin">
      <p class="font-medium">
        <span [innerHTML]="highlightMatchText(admin.name) | safeHtml"></span>
      </p>
      <p class="font-bold text-green-500">{{ admin.code }}</p>
    </ng-container>
  </ng-template>
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
